import { digObject, formatDate } from '@domain-group/javascript-utils'

import { Form, ListItem, Text } from '@domain-group/suit-theme'

import { BookingModel } from '@domain-group/realhub-backend-api-types'

import { generateUrls } from '@hooks/useBooking'
import useCurrentUser from '@hooks/useCurrentUser'
import useLoginAsUser from '@hooks/useLoginAsUser'

type InvoicePayloadProps = {
  booking: BookingModel,
  currentUserPayload: ReturnType<typeof useCurrentUser>,
}

const LinkedBookingAndPackages = (props: InvoicePayloadProps) => {
  const { booking, currentUserPayload } = props

  const { currentUser, isProviderUser } = currentUserPayload
  const { id: providerUserId } = currentUser

  const userId = digObject(booking, 'admin.id', '')

  const date = digObject(booking, 'dates.start.date_time', '')
  const formattedDate = formatDate(date, 'dd/MM/yyyy HH:mm', "ccc d LLL 'at' ta")

  const titleAndMobile = `${booking?.title} - ${formattedDate}`

  const { providerDashboardBookingCalendarUrl } = generateUrls(booking)

  const { callbacks: { loginAsUser } } = useLoginAsUser({
    redirect: providerDashboardBookingCalendarUrl,
    userId: isProviderUser ? providerUserId : userId,
  })

  return (
    <ListItem
      boxProps={{
        fontSize: 'small', borderBottom: '1px solid', padding: 'large', as: 'a',
      }}
      onClick={() => loginAsUser()}
      showAngleIcon
    >
      <Form.Field
        label="Booking"
        labelProps={{ style: { alignItems: 'center', padding: 'large' } }}
      >
        <Text fontSize="small">
          {titleAndMobile}
        </Text>
      </Form.Field>
    </ListItem>
  )
}
export default LinkedBookingAndPackages
